import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx } from "vue"
import _imports_0 from '../assets/img/logo_new.png'


const _hoisted_1 = ["href"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Location Garde-meuble",
  width: "77",
  height: "50"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "header-text" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createTextVNode(" Location-gardemeuble"),
    /*#__PURE__*/_createElementVNode("span", null, ".fr")
  ]),
  /*#__PURE__*/_createElementVNode("div", null, " Avis, conseils, réservations garde-meuble et self-stockage ")
], -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]
const _hoisted_5 = {
  id: "menu-right",
  style: {"margin":"0"}
}
const _hoisted_6 = { class: "menu-mobile" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Trouver mon box ")
const _hoisted_9 = ["href"]
const _hoisted_10 = ["href"]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("a", {
  href: "https://blog.location-gardemeuble.fr/",
  class: "menu-button"
}, " Le Mag' ", -1)
const _hoisted_12 = ["href"]
const _hoisted_13 = ["href"]
const _hoisted_14 = ["href"]
const _hoisted_15 = {
  key: 1,
  class: "only-mobile"
}
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" Menu principal ")
const _hoisted_17 = /*#__PURE__*/_createElementVNode("ul", {
  class: "mobile-departement-list only-mobile",
  style: {"text-align":"left","list-style":"none","padding-left":"1em","margin-top":"0.5em"}
}, [
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("a", { href: "https://www.location-gardemeuble.fr/garde-meuble-bourg-en-bresse-01000-r" }, "Ain")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("a", { href: "https://www.location-gardemeuble.fr/garde-meuble-saint-quentin-02100-r" }, "Aisne")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("a", { href: "https://www.location-gardemeuble.fr/garde-meuble-montlucon-03100-r" }, "Allier")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("a", { href: "https://www.location-gardemeuble.fr/garde-meuble-manosque-04100-r" }, "Alpes de Haute-Provence")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("a", { href: "https://www.location-gardemeuble.fr/garde-meuble-gap-05000-r" }, "Hautes-Alpes")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("a", { href: "https://www.location-gardemeuble.fr/garde-meuble-nice-06000-r" }, "Alpes-Maritimes")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("a", { href: "https://www.location-gardemeuble.fr/garde-meuble-annonay-07100-r" }, "Ardèche")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("a", { href: "https://www.location-gardemeuble.fr/garde-meuble-charleville-mezieres-08090-r" }, "Ardennes")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("a", { href: "https://www.location-gardemeuble.fr/garde-meuble-pamiers-09100-r" }, "Ariège")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("a", { href: "https://www.location-gardemeuble.fr/garde-meuble-troyes-10000-r" }, "Aube")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("a", { href: "https://www.location-gardemeuble.fr/garde-meuble-narbonne-11100-r" }, "Aude")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("a", { href: "https://www.location-gardemeuble.fr/garde-meuble-rodez-12000-r" }, "Aveyron")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("a", { href: "https://www.location-gardemeuble.fr/garde-meuble-marseille-13000-r" }, "Bouches-du-Rhône")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("a", { href: "https://www.location-gardemeuble.fr/garde-meuble-caen-14000-r" }, "Calvados")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("a", { href: "https://www.location-gardemeuble.fr/garde-meuble-aurillac-15000-r" }, "Cantal")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("a", { href: "https://www.location-gardemeuble.fr/garde-meuble-angouleme-16000-r" }, "Charente")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("a", { href: "https://www.location-gardemeuble.fr/garde-meuble-la-rochelle-17000-r" }, "Charente-Maritime")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("a", { href: "https://www.location-gardemeuble.fr/garde-meuble-bourges-18000-r" }, "Cher")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("a", { href: "https://www.location-gardemeuble.fr/garde-meuble-brive-la-gaillarde-19100-r" }, "Corrèze")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("a", { href: "https://www.location-gardemeuble.fr/garde-meuble-ajaccio-20000-r" }, "Corse-du-Sud")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("a", { href: "https://www.location-gardemeuble.fr/garde-meuble-bastia-20200-r" }, "Haute-Corse")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("a", { href: "https://www.location-gardemeuble.fr/garde-meuble-dijon-21000-r" }, "Côte-d'Or")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("a", { href: "https://www.location-gardemeuble.fr/garde-meuble-saint-brieuc-22000-r" }, "Côtes-d'Armor")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("a", { href: "https://www.location-gardemeuble.fr/garde-meuble-gueret-23000-r" }, "Creuse")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("a", { href: "https://www.location-gardemeuble.fr/garde-meuble-perigueux-24000-r" }, "Dordogne")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("a", { href: "https://www.location-gardemeuble.fr/garde-meuble-besancon-25000-r" }, "Doubs")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("a", { href: "https://www.location-gardemeuble.fr/garde-meuble-valence-26000-r" }, "Drôme")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("a", { href: "https://www.location-gardemeuble.fr/garde-meuble-evreux-27000-r" }, "Eure")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("a", { href: "https://www.location-gardemeuble.fr/garde-meuble-chartres-28000-r" }, "Eure-et-Loir")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("a", { href: "https://www.location-gardemeuble.fr/garde-meuble-brest-29200-r" }, "Finistère")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("a", { href: "https://www.location-gardemeuble.fr/garde-meuble-nimes-30000-r" }, "Gard")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("a", { href: "https://www.location-gardemeuble.fr/garde-meuble-toulouse-31000-r" }, "Haute-Garonne")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("a", { href: "https://www.location-gardemeuble.fr/garde-meuble-auch-32810-r" }, "Gers")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("a", { href: "https://www.location-gardemeuble.fr/garde-meuble-bordeaux-33000-r" }, "Gironde")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("a", { href: "https://www.location-gardemeuble.fr/garde-meuble-montpellier-34000-r" }, "Hérault")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("a", { href: "https://www.location-gardemeuble.fr/garde-meuble-rennes-35000-r" }, "Ille-et-Vilaine")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("a", { href: "https://www.location-gardemeuble.fr/garde-meuble-chateauroux-36000-r" }, "Indre")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("a", { href: "https://www.location-gardemeuble.fr/garde-meuble-tours-37000-r" }, "Indre-et-Loire")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("a", { href: "https://www.location-gardemeuble.fr/garde-meuble-grenoble-38000-r" }, "Isère")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("a", { href: "https://www.location-gardemeuble.fr/garde-meuble-dole-39100-r" }, "Jura")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("a", { href: "https://www.location-gardemeuble.fr/garde-meuble-mont-de-marsan-40000-r" }, "Landes")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("a", { href: "https://www.location-gardemeuble.fr/garde-meuble-blois-41000-r" }, "Loir-et-Cher")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("a", { href: "https://www.location-gardemeuble.fr/garde-meuble-saint-etienne-42000-r" }, "Loir")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("a", { href: "https://www.location-gardemeuble.fr/garde-meuble-le-puy-en-velay-43000-r" }, "Haute-Loire")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("a", { href: "https://www.location-gardemeuble.fr/garde-meuble-nantes-44000-r" }, "Loire-Atlantique")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("a", { href: "https://www.location-gardemeuble.fr/garde-meuble-orleans-45000-r" }, "Loiret")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("a", { href: "https://www.location-gardemeuble.fr/garde-meuble-cahors-46000-r" }, "Lot")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("a", { href: "https://www.location-gardemeuble.fr/garde-meuble-agen-47000-r" }, "Lot-et-Garonne")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("a", { href: "https://www.location-gardemeuble.fr/garde-meuble-mende-48000-r" }, "Lozère")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("a", { href: "https://www.location-gardemeuble.fr/garde-meuble-angers-49000-r" }, "Maine-et-Loire")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("a", { href: "https://www.location-gardemeuble.fr/garde-meuble-cherbourg-en-cotentin-50100-r" }, "Manche")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("a", { href: "https://www.location-gardemeuble.fr/garde-meuble-reims-51100-r" }, "Marne")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("a", { href: "https://www.location-gardemeuble.fr/garde-meuble-saint-dizier-52100-r" }, "Haute-Marne")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("a", { href: "https://www.location-gardemeuble.fr/garde-meuble-laval-53000-r" }, "Mayenne")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("a", { href: "https://www.location-gardemeuble.fr/garde-meuble-nancy-54100-r" }, "Meurthe-et-Moselle")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("a", { href: "https://www.location-gardemeuble.fr/garde-meuble-bar-le-duc-55000-r" }, "Meuse")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("a", { href: "https://www.location-gardemeuble.fr/garde-meuble-lorient-56100-r" }, "Morbihan")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("a", { href: "https://www.location-gardemeuble.fr/garde-meuble-metz-57000-r" }, "Moselle")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("a", { href: "https://www.location-gardemeuble.fr/garde-meuble-nevers-58000-r" }, "Nièvre")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("a", { href: "https://www.location-gardemeuble.fr/garde-meuble-lille-59000-r" }, "Nord")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("a", { href: "https://www.location-gardemeuble.fr/garde-meuble-beauvais-60155-r" }, "Oise")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("a", { href: "https://www.location-gardemeuble.fr/garde-meuble-alencon-61000-r" }, "Orne")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("a", { href: "https://www.location-gardemeuble.fr/garde-meuble-calais-62100-r" }, "Pas-de-Calais")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("a", { href: "https://www.location-gardemeuble.fr/garde-meuble-clermont-ferrand-63000-r" }, "Puy-de-Dôme")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("a", { href: "https://www.location-gardemeuble.fr/garde-meuble-pau-64000-r" }, "Pyrénées-Atlantiques")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("a", { href: "https://www.location-gardemeuble.fr/garde-meuble-tarbes-65000-r" }, "Hautes-Pyrénées")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("a", { href: "https://www.location-gardemeuble.fr/garde-meuble-perpignan-66000-r" }, "Pyrénées-Orientales")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("a", { href: "https://www.location-gardemeuble.fr/garde-meuble-strasbourg-67000-r" }, "Bas-Rhin")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("a", { href: "https://www.location-gardemeuble.fr/garde-meuble-mulhouse-68100-r" }, "Haut-Rhin")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("a", { href: "https://www.location-gardemeuble.fr/garde-meuble-lyon-69000-r" }, "Rhône")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("a", { href: "https://www.location-gardemeuble.fr/garde-meuble-vesoul-70000-r" }, "Hautes-Saône")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("a", { href: "https://www.location-gardemeuble.fr/garde-meuble-chalon-sur-saone-71100-r" }, "Saône-et-Loire")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("a", { href: "https://www.location-gardemeuble.fr/garde-meuble-le-mans-72000-r" }, "Sarthe")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("a", { href: "https://www.location-gardemeuble.fr/garde-meuble-chambery-73000-r" }, "Savoie")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("a", { href: "https://www.location-gardemeuble.fr/garde-meuble-annecy-74000-r" }, "Haute-Savoie")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("a", { href: "https://www.location-gardemeuble.fr/garde-meuble-paris-75000-r" }, "Paris")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("a", { href: "https://www.location-gardemeuble.fr/garde-meuble-le-havre-76600-r" }, "Seine-Maritime")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("a", { href: "https://www.location-gardemeuble.fr/garde-meuble-meaux-77100-r" }, "Seine-et-Marne")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("a", { href: "https://www.location-gardemeuble.fr/garde-meuble-versailles-78000-r" }, "Yvelines")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("a", { href: "https://www.location-gardemeuble.fr/garde-meuble-niort-79000-r" }, "Deux-Sévres")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("a", { href: "https://www.location-gardemeuble.fr/garde-meuble-amiens-80000-r" }, "Somme")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("a", { href: "https://www.location-gardemeuble.fr/garde-meuble-albi-81990-r" }, "Tarn")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("a", { href: "https://www.location-gardemeuble.fr/garde-meuble-montauban-82000-r" }, "Tarn-et-Garonne")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("a", { href: "https://www.location-gardemeuble.fr/garde-meuble-toulon-83000-r" }, "Var")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("a", { href: "https://www.location-gardemeuble.fr/garde-meuble-avignon-84000-r" }, "Vaucluse")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("a", { href: "https://www.location-gardemeuble.fr/garde-meuble-la-roche-sur-yon-85000-r" }, "Vendée")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("a", { href: "https://www.location-gardemeuble.fr/garde-meuble-poitiers-86000-r" }, "Vienne")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("a", { href: "https://www.location-gardemeuble.fr/garde-meuble-limoges-87000-r" }, "Haute-Vienne")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("a", { href: "https://www.location-gardemeuble.fr/garde-meuble-epinal-88000-r" }, "Vosges")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("a", { href: "https://www.location-gardemeuble.fr/garde-meuble-auxerre-89000-r" }, "Yonne")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("a", { href: "https://www.location-gardemeuble.fr/garde-meuble-belfort-90000-r" }, "Territoire de Belfort")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("a", { href: "https://www.location-gardemeuble.fr/garde-meuble-evry-courcouronnes-91000-r" }, "Essonne")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("a", { href: "https://www.location-gardemeuble.fr/garde-meuble-boulogne-billancourt-92100-r" }, "Hauts-de-Seine")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("a", { href: "https://www.location-gardemeuble.fr/garde-meuble-montreuil-93100-r" }, "Seine-Saint-Denis")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("a", { href: "https://www.location-gardemeuble.fr/garde-meuble-creteil-94000-r" }, "Val-de-Marne")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("a", { href: "https://www.location-gardemeuble.fr/garde-meuble-argenteuil-95100-r" }, "Val-d'Oise")
  ])
], -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "menu-spacer" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("section", null, [
    _createElementVNode("header", null, [
      _createElementVNode("a", {
        href: _ctx.$router.resolve({name: 'home'}).href,
        class: "logo"
      }, _hoisted_4, 8, _hoisted_1),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_Transition, { name: "fade" }, {
          default: _withCtx(() => [
            _withDirectives(_createElementVNode("div", _hoisted_6, [
              (this.show_find === false)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _createElementVNode("a", {
                      href: "#",
                      onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (this.show_find = !this.show_find), ["prevent"])),
                      class: "menu-button only-mobile"
                    }, [
                      _hoisted_8,
                      _createVNode(_component_font_awesome_icon, {
                        icon: "caret-right",
                        style: {"float":"right","font-size":"2em","position":"relative","top":"-0.2em","right":"0.2em"}
                      })
                    ]),
                    _createElementVNode("a", {
                      href: _ctx.$router.resolve({name: 'calculateur'}).href,
                      class: "menu-button only-mobile"
                    }, " Evaluez votre volume ", 8, _hoisted_9),
                    _createElementVNode("a", {
                      href: _ctx.$router.resolve({name: 'editable-17'}).href,
                      class: "menu-button only-mobile"
                    }, " Notre entreprise ", 8, _hoisted_10),
                    _hoisted_11,
                    _createElementVNode("a", {
                      href: this.store.state.base_url + 'guide-demenagement-sommaire',
                      class: "menu-button"
                    }, " Guide du déménagement ", 8, _hoisted_12),
                    _createElementVNode("a", {
                      href: this.store.state.base_url + 'guide-du-garde-meuble',
                      class: "menu-button"
                    }, " Guide du garde meuble ", 8, _hoisted_13),
                    _createElementVNode("a", {
                      href: this.store.state.base_url + 'proposer-votre-garde-meuble',
                      class: "adhesion-button"
                    }, " Proposer votre garde meuble ", 8, _hoisted_14)
                  ]))
                : _createCommentVNode("", true),
              (this.show_find === true)
                ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                    _createElementVNode("a", {
                      href: "#",
                      onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (this.show_find = !this.show_find), ["prevent"])),
                      class: "menu-button only-mobile"
                    }, [
                      _createVNode(_component_font_awesome_icon, {
                        icon: "caret-left",
                        style: {"float":"left","font-size":"2em","position":"relative","top":"-0.2em","margin-right":"0.2em"}
                      }),
                      _hoisted_16
                    ]),
                    _createElementVNode("a", {
                      href: "#",
                      onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["prevent"])),
                      class: "only-mobile",
                      style: {"background":"transparent","color":"white","display":"block","text-align":"left","margin":"1em 0.75em 0"}
                    }, " Trouver mon box en France "),
                    _hoisted_17
                  ]))
                : _createCommentVNode("", true)
            ], 512), [
              [_vShow, _ctx.show_menu]
            ])
          ]),
          _: 1
        }),
        _createElementVNode("a", {
          href: "#",
          class: "mobile-bars",
          onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.show_menu = !_ctx.show_menu), ["prevent"])),
          "aria-label": "Ouvrir le menu déroulant"
        }, [
          _createVNode(_component_font_awesome_icon, { icon: "bars" })
        ])
      ])
    ]),
    _hoisted_18
  ]))
}